var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 16,
    viewBox: "0 0 45 16",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44.4857 8.70711C44.8762 8.31658 44.8762 7.68342 44.4857 7.29289L38.1217 0.928932C37.7312 0.538408 37.098 0.538408 36.7075 0.928932C36.317 1.31946 36.317 1.95262 36.7075 2.34315L42.3644 8L36.7075 13.6569C36.317 14.0474 36.317 14.6805 36.7075 15.0711C37.098 15.4616 37.7312 15.4616 38.1217 15.0711L44.4857 8.70711ZM0 9H43.7786V7H0V9Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight1);
export default __webpack_public_path__ + "static/media/arrow_right_1.dd3c5b3b3dc9a4a7e2ee46b601fccbbe.svg";
export { ForwardRef as ReactComponent };